import { FC } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger } from './ui/select';
import { cn } from '../utils/cn';
import * as ScrollArea from '@radix-ui/react-scroll-area';
type RoundSelectorProps = {
  currentRoundId: number;
  className?: string;
  rounds: number[];
  roundName?: (roundId: number) => string | undefined | null;
  includeAllRoundsOption?: boolean;
  onSelect: (roundId: number) => void;
};
export const RoundSelector: FC<RoundSelectorProps> = ({
  currentRoundId,
  className,
  rounds,
  roundName,
  includeAllRoundsOption,
  onSelect
}) => {
  const handleValueChange = (value: string) => {
    onSelect(parseInt(value, 10));
  };
  const currentRound = currentRoundId === 0 && includeAllRoundsOption ? 0 : rounds.find(round => round === currentRoundId);
  const currentRoundName = currentRound ? roundName?.(currentRound) : null;
  return <Select value={String(currentRound)} onValueChange={handleValueChange} data-sentry-element="Select" data-sentry-component="RoundSelector" data-sentry-source-file="round-selector.tsx">
      <SelectTrigger className={cn('w-[180px] lg:w-[350px] whitespace-nowrap', className)} data-sentry-element="SelectTrigger" data-sentry-source-file="round-selector.tsx">
        {currentRound === 0 && includeAllRoundsOption ? 'All Rounds' : `Round ${currentRound}${currentRoundName ? `- ${currentRoundName}` : ''}`}
      </SelectTrigger>
      <SelectContent className="absolute left-0 mt-2 w-auto origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-hidden" data-sentry-element="SelectContent" data-sentry-source-file="round-selector.tsx">
        <ScrollArea.Root type="auto" data-sentry-element="unknown" data-sentry-source-file="round-selector.tsx">
          <ScrollArea.Viewport className="w-full h-full max-h-[40vh] p-1" data-sentry-element="unknown" data-sentry-source-file="round-selector.tsx">
            {includeAllRoundsOption && <SelectItem value="0">All Rounds</SelectItem>}
            {rounds.map(round => <SelectItem key={round} value={String(round)}>
                Round {round}
                {roundName ? ` - ${roundName(round)}` : ''}
              </SelectItem>)}
          </ScrollArea.Viewport>
          <ScrollArea.Scrollbar className="flex select-none touch-none p-0.5 bg-gray-100 transition-colors duration-150 ease-out hover:bg-gray-200 w-3" orientation="vertical" data-sentry-element="unknown" data-sentry-source-file="round-selector.tsx">
            <ScrollArea.Thumb className="relative flex-1 bg-gray-400 rounded-full before:absolute before:left-1/2 before:top-1/2 before:size-full before:min-h-11 before:min-w-11 before:-translate-x-1/2 before:-translate-y-1/2" data-sentry-element="unknown" data-sentry-source-file="round-selector.tsx" />
          </ScrollArea.Scrollbar>
        </ScrollArea.Root>
      </SelectContent>
    </Select>;
};